<template>
  <section class="quote-info">
    <div class="box">
      <div class="table mg-b-10">
        <div class="tr">
          <span>Insured Period</span>
          <span
            v-copy="formData.insurance_period"
            :class="{'green-tip':handleCompare('insurance_period')}">{{ formData.insurance_period}}</span>
        </div>
        <div class="tr">
          <span>Expected Insured Period</span>
          <span
            v-copy="formData.period_date"
            :class="{'green-tip':handleCompare('period_date')}">
            {{ formData.period_date }}
            <span
              v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
              class="asap">(ASAP)</span>
          </span>
        </div>
        <div class="tr">
          <span>Total Price</span>
          <span
            v-if="showAmount"
            v-copy="amount"
            :class="{'green-tip':isChange}">{{ showAmount | formatMoney(2, true) }}</span>
        </div>
        <div class="tr">
          <span>Referrer</span>
          <span
            v-if="referrer"
            class="flex-column">
            <router-link
              :to="{path:'/accounts/detail',query:{customer_id:referrer.id}}"
              class="flex flex-wrap text-decoration-none">
              <span
                class="referrer"
                @click="handlerUser(referrer.id)">
                {{referrer.identity==2?referrer.isrd_com_nm:`${referrer.isrd_lst_nm||''} ${referrer.isrd_fst_nm||''}`}}
              </span>
            </router-link>
            <div class="tags">
              <span
                v-if="referrer.is_tier_base"
                class="span-status blue">
                Professional
              </span>
              <span
                v-if="referrer.verify_language"
                class="span-status"
                :class="{
                  'verified': referrer.verified == 20,
                  'pending_verify ': referrer.verified == -1,
                  'not_verify': referrer.verified == -2
                }">
                {{ referrer.verify_language }}
              </span>
              <span
                v-if="referrer.is_flagged"
                class="span-status flag">
                Flagged
              </span>
            </div>
          </span>
        </div>
        <!--        <div-->
        <!--          v-if="formData.discount_str"-->
        <!--          class="tr">-->
        <!--          <span>Referrer Discount</span>-->
        <!--          <span>{{formData.discount_str}}</span>-->
        <!--        </div>-->
        <div
          v-if="!isEndorse"
          class="tr">
          <span>Policy Number </span>
          <span
            v-copy="formData.pcy_no"
            :class="{'green-tip':handleCompare('pcy_no')}">{{ formData.pcy_no  }}</span>
        </div>
        <div
          v-else
          class="tr">
          <span>Endorsement Number </span>
          <span
            v-copy="formData.endorser_no"
            :class="{'green-tip':handleCompare('endorser_no')}">{{ formData.endorser_no  }}</span>
        </div>
        <div class="tr">
          <span>Policy Reference Code </span>
          <span
            v-copy="formData.order_sn"
            :class="{'green-tip':handleCompare('order_sn')}">{{ formData.order_sn }}</span>
        </div>
        <div class="tr">
          <span>Type of Building</span>
          <span
            v-copy="getAllOptionName26('bldg_types', formData.bldg_typ)"
            :class="{'green-tip':handleCompare('bldg_typ')}">{{ getAllOptionName26('bldg_types', formData.bldg_typ) }}</span>
        </div>
        <div class="tr">
          <span>Gross Floor Area (Indoor & Outdoor)</span>
          <span
            v-copy="formData.floor_area"
            :class="{'green-tip':handleCompare('floor_area')}">{{  formData.floor_area}}</span>
        </div>
        <div class="tr">
          <span>Coverage</span>
          <span
            v-copy="getAllOptionName26('coverage', formData.coverage_id)"
            :class="{'green-tip':handleCompare('coverage_id')}">{{ getAllOptionName26('coverage', formData.coverage_id) }}</span>
        </div>
        <template v-if="formData.coverage_id==3">
          <div class="tr">
            <span>Sum Insured of Building Structure</span>
            <span
              v-copy="formData.bsc_sum_insured"
              :class="{'green-tip':handleCompare('bsc_sum_insured')}">{{  formData.bsc_sum_insured | formatMoney(2, true) }}</span>
          </div>
          <div class="tr">
            <span>Do you need us to post a copy of the policy document to the Mortgagee?</span>
            <span
              v-copy="getOptionName('yesNoOptions', formData.post_ind)"
              :class="{'green-tip':handleCompare('post_ind')}">{{ getOptionName('yesNoOptions', formData.post_ind) }}</span>
          </div>
          <div
            v-if="formData.post_ind"
            class="tr">
            <span>Name of Mortgagee</span>
            <span
              v-copy="`${getAllOptionName26('mortgagor',formData.post_nm_id)} ${isOther?formData.post_nm_other:''}`"
              :class="{'green-tip':handleCompare('post_nm_id')}">{{getAllOptionName26('mortgagor',formData.post_nm_id)}} {{isOther?formData.post_nm_other:''}}</span>
          </div>
          <div
            v-if="formData.post_ind"
            class="tr">
            <span>Address of Mortgagee</span>
            <span
              v-copy="formData.post_addr"
              :class="{'green-tip':handleCompare('post_addr')}">{{  formData.post_addr}}</span>
          </div>
        </template>
        <div class="tr">
          <span>Property Age </span>
          <span
            v-copy="getAllOptionName26('prop_age', formData.prop_age)"
            :class="{'green-tip':handleCompare('prop_age')}">{{ getAllOptionName26('prop_age', formData.prop_age) }}</span>
        </div>
        <div class="tr">
          <span>Occupancy</span>
          <span
            v-copy="getAllOptionName26('prop_insured', formData.prop_insured)"
            :class="{'green-tip':handleCompare('prop_insured')}">{{ getAllOptionName26('prop_insured', formData.prop_insured) }}</span>
        </div>
        <div class="tr">
          <span>Is your Location of Risk same as Correspondence Address?</span>
          <span
            v-copy="getOptionName('yesNoOptions', formData.is_same_as_corr_addr)"
            :class="{'green-tip':handleCompare('is_same_as_corr_addr')}">{{ getOptionName('yesNoOptions', formData.is_same_as_corr_addr) }}</span>
        </div>
        <div
          v-if="option_benefits.length>0"
          class="tr">
          <span>Optional Benefits</span>
          <span>
            <span
              v-for="(item,index) in option_benefits"
              :key="'extra'+index"
              v-copy="item.item">{{item.item}}<br></span>
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="excessList.length>0"
      class="box">
      <h3>Excess</h3>
      <div class="table">
        <div class="tr th">
          <span>Item</span>
          <span>Amount</span>
        </div>
        <div
          v-for="(inItem, index) in excessList"
          :key="index"
          class="sub">
          <span class="sub-title">{{ inItem.sub_title }}</span>
          <template
            v-for="(val,i) in inItem.sub_items">
            <p
              :key="i"
              v-copy="val.item">{{ val.item }}</p>
          </template>
        </div>
        <div class="tr">
          <span>Excess Remark</span>
          <span
            v-copy="changeLineData(formData.quote_remark)"
            :class="{'green-tip':handleCompare('quote_remark')}"
            v-html="changeLineData(formData.quote_remark)"></span>
        </div>
      </div>
    </div>
    <div class="box">
      <div
        v-for="(excessItem, excessIndex) in coverageList.items"
        :key="'coverage' + excessIndex">
        <div
          v-if="excessItem.sub_items.length>0"
          class="table">
          <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
          <div
            v-if="excessIndex==0"
            class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'coverage-' + excessIndex + subIndex"
            class="tr">
            <span>{{ subItem.item }}</span>
            <span v-copy="subItem.premium">{{ subItem.premium }}</span>
          </div>
          <div class="tr">
            <span>Coverage Remark</span>
            <span
              v-copy="changeLineData(formData.cvr_remark)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(formData.cvr_remark)"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <h3>Location of Risk</h3>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span
            v-copy="isSameAddress? formData.addr_room :formData.insured_addr_room"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_room')}">{{ isSameAddress? formData.addr_room :formData.insured_addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span
            v-copy="isSameAddress? formData.addr_floor :formData.insured_addr_floor"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_floor')}">{{ isSameAddress? formData.addr_floor :formData.insured_addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span
            v-copy="isSameAddress? formData.addr_block :formData.insured_addr_block"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_block')}">{{ isSameAddress? formData.addr_block :formData.insured_addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span
            v-copy="isSameAddress? formData.addr_building :formData.insured_addr_building"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_building')}">{{ isSameAddress? formData.addr_building :formData.insured_addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span
            v-copy="isSameAddress? formData.addr_street :formData.insured_addr_street"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_street')}">{{ isSameAddress? formData.addr_street :formData.insured_addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span
            v-copy="getAreaName('district', isSameAddress? formData.addr_district :formData.insured_addr_district)"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_district')}">{{ getAreaName('district', isSameAddress? formData.addr_district :formData.insured_addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span
            v-copy="getAreaName('area', isSameAddress? formData.addr_area :formData.insured_addr_area)"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_area')}">{{ getAreaName('area', isSameAddress? formData.addr_area :formData.insured_addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span
            v-copy="getAreaName('region', isSameAddress? formData.addr_region :formData.insured_addr_region)"
            :class="{'green-tip':!isSameAddress&&handleCompare('insured_addr_region')}">{{ getAreaName('region', isSameAddress? formData.addr_region :formData.insured_addr_region) }}</span>
        </div>
      </div>
    </div>

    <div class="box">
      <h2>Policyholder Detail</h2>
      <div class="table">
        <template v-if="formData.cust_typ == 1">
          <div class="tr">
            <span>Title</span>
            <span
              v-copy="getOptionName('titleOptions', formData.isrd_title)"
              :class="{'green-tip':handleCompare('isrd_title')}">{{ getOptionName('titleOptions', formData.isrd_title) }}</span>
          </div>
          <div class="tr">
            <span>Last Name</span>
            <span
              v-copy="formData.isrd_lst_nm "
              :class="{'green-tip':handleCompare('isrd_lst_nm')}">{{ formData.isrd_lst_nm }}</span>
          </div>
          <div class="tr">
            <span>First Name</span>
            <span
              v-copy="formData.isrd_fst_nm"
              :class="{'green-tip':handleCompare('isrd_fst_nm')}">{{ formData.isrd_fst_nm }}</span>
          </div>
          <div class="tr">
            <span>Date of Birth</span>
            <span
              v-copy="formData.isrd_dob_date"
              :class="{'green-tip':handleCompare('isrd_dob_date')}">{{ formData.isrd_dob_date }}</span>
          </div>
          <div class="tr">
            <span>HKID</span>
            <span
              v-copy="formData.id_no"
              :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</span>
          </div>
          <div class="tr">
            <span>Mobile Number</span>
            <span
              v-copy="formData.mobile_no"
              :class="{'green-tip':handleCompare('mobile_no')}">{{ formData.mobile_no }}</span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span
              v-copy="formData.email"
              :class="{'green-tip':handleCompare('email')}">
              {{ formData.email }}
              <email-tooltip :email="formData.email"></email-tooltip>
            </span>
          </div>
          <div class="tr">
            <span>Occupation</span>
            <span
              v-copy="formData.occ"
              :class="{'green-tip':handleCompare('occ }}')}">{{ formData.occ }}</span>
          </div>
          <template v-if="isShowOwners">
            <div class="tr">
              <span>Are there joint owners?</span>
              <span
                v-copy="getOptionName('yesNoOptions',formData.joint_owner_ind)"
                :class="{'green-tip':handleCompare('joint_owner_ind }}')}">{{ getOptionName('yesNoOptions',formData.joint_owner_ind) }}</span>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="tr">
            <span>Company Name</span>
            <span
              v-copy="formData.isrd_com_nm"
              :class="{'green-tip':handleCompare('isrd_com_nm')}">{{ formData.isrd_com_nm }}</span>
          </div>
          <div class="tr">
            <span>Business Registration Number</span>
            <span
              v-copy="formData.id_no"
              :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</span>
          </div>
          <!--          <div class="tr">-->
          <!--            <span>CI Number</span>-->
          <!--            <span>{{ formData.ci_no }}</span>-->
          <!--          </div>-->
          <div class="tr">
            <span>Company Phone No.</span>
            <span
              v-copy="formData.phone_no"
              :class="{'green-tip':handleCompare('phone_no')}">{{ formData.phone_no }}</span>
          </div>
          <div class="tr">
            <span>Company Email</span>
            <span
              v-copy="formData.email"
              :class="{'green-tip':handleCompare('email')}">
              {{ formData.email }}
              <email-tooltip :email="formData.email"></email-tooltip>
            </span>
          </div>
          <div class="tr">
            <span>Nature of Business</span>
            <span
              v-copy="getAllOptionName29('industry', formData.bsns_nature_id)"
              :class="{'green-tip':handleCompare('bsns_nature_id')}">{{ getAllOptionName29('industry', formData.bsns_nature_id) }}</span>
          </div>
          <template v-if="isShowOwners">
            <div class="tr">
              <span>Are there joint owners?</span>
              <span
                v-copy="getOptionName('yesNoOptions',formData.joint_owner_ind)"
                :class="{'green-tip':handleCompare('joint_owner_ind }}')}">{{ getOptionName('yesNoOptions',formData.joint_owner_ind) }}</span>
            </div>
          </template>
          <span class="title">Contact Person</span>
          <div class="tr">
            <span>Name</span>
            <span
              v-copy="formData.contact_nm"
              :class="{'green-tip':handleCompare('contact_nm')}">{{ formData.contact_nm }}</span>
          </div>
          <div class="tr">
            <span>Occupation</span>
            <span
              v-copy="getAllOptionName24('occupation', formData.contact_occ_id)"
              :class="{'green-tip':handleCompare('contact_occ_id')}">{{ getAllOptionName24('occupation', formData.contact_occ_id) }}</span>
          </div>
          <div class="tr">
            <span>Phone No.</span>
            <span
              v-copy="formData.contact_phone"
              :class="{'green-tip':handleCompare('contact_phone')}">{{ formData.contact_phone }}</span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span
              v-copy="formData.contact_email"
              :class="{'green-tip':handleCompare('contact_email')}">
              {{ formData.contact_email }}
              <email-tooltip :email="formData.email"></email-tooltip>
            </span>
          </div>
        </template>
      </div>
    </div>
    <template  v-if="formData.joint_owner_ind==1">
      <div class="box">
        <h3>Joint Policyholder Details</h3>
        <div class="table">

          <div
            class="tr">
            <span>Joint Policyholder - Full Name</span>
            <span
              v-copy="formData.joint_owner_nm"
            >{{formData.joint_owner_nm}}</span>
          </div>
          <div
            class="tr">
            <span>Date of Birth</span>
            <span
              v-copy="formData.joint_owner_dob"
            >{{showHKDate(formData.joint_owner_dob)}}</span>
          </div>
          <div
            class="tr">
            <span>Joint Policyholder - {{getOptionName('personalIdTypOptions',formData.joint_owner_id_type)}}</span>
            <span
              v-copy="formData.joint_owner_id_no"
            >{{formData.joint_owner_id_no}}</span>
          </div>
        </div>
      </div>
    </template>
    <div class="box">
      <h3>Correspondence Address</h3>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span
            v-copy="formData.addr_room"
            :class="{'green-tip':handleCompare('addr_room')}">{{ formData.addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span
            v-copy="formData.addr_floor"
            :class="{'green-tip':handleCompare('addr_floor')}">{{ formData.addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span
            v-copy="formData.addr_block"
            :class="{'green-tip':handleCompare('addr_block')}">{{ formData.addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span
            v-copy="formData.addr_building"
            :class="{'green-tip':handleCompare('addr_building')}">{{ formData.addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span
            v-copy="formData.addr_street"
            :class="{'green-tip':handleCompare('addr_street')}">{{ formData.addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span
            v-copy="getAreaName('district', formData.addr_district)"
            :class="{'green-tip':handleCompare('addr_district')}">{{ getAreaName('district', formData.addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span
            v-copy="getAreaName('area', formData.addr_area)"
            :class="{'green-tip':handleCompare('addr_area')}">{{ getAreaName('area', formData.addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span
            v-copy="getAreaName('region', formData.addr_region)"
            :class="{'green-tip':handleCompare('addr_region')}">{{ getAreaName('region', formData.addr_region) }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="hasBenefitsTab"
      class="box">
      <h3>More Benefits Detail</h3>
      <template v-if="hasBenefitsEmployees">
        <h4>Domestic Helper Information</h4>
        <div
          v-for="(item, index) in domesticHelperInfoList"
          :key="index"
          class="table">
          <div class="tr th">
            <span>Field</span>
            <span>Domestic Helper {{ index+1 }}</span>
          </div>
          <div class="tr">
            <span>Name</span>
            <span
              v-copy="item.name"
              :class="{'green-tip':compareChange(index,'domestic_helper_info','name')}">{{ item.name }}</span>
          </div>
          <div class="tr">
            <span>Nationality</span>
            <span
              v-copy="getName(item.nationality)"
              :class="{'green-tip':compareChange(index,'domestic_helper_info','nationality')}">{{ getName(item.nationality) }}</span>
          </div>
          <div class="tr">
            <span>Date of Birth</span>
            <span
              v-copy="item.dob_date"
              :class="{'green-tip':compareChange(index,'domestic_helper_info','dob_date')}">{{ item.dob_date }}</span>
          </div>
          <div class="tr">
            <span>HKID / Passport Number</span>
            <span
              v-copy="item.id_no"
              :class="{'green-tip':compareChange(index,'domestic_helper_info','id_no')}">{{ item.id_no }}</span>
          </div>
          <!-- <div class="tr">
            <span>HKID / Passport</span>
            <span
              class="blue pointer"
              @click="openFile(item.id_type_pic.url)">{{ item.id_type_pic? item.id_type_pic.client_name: '' }}</span>
          </div> -->
        </div>
      </template>
      <template v-if="hasBenefitsPets">
        <h4>Pet Information</h4>
        <div
          v-for="(item, index) in formData.pet_info"
          :key="index"
          class="table">
          <div class="tr th">
            <span>Field</span>
            <span>Pet {{ index+1 }}</span>
          </div>
          <div class="tr">
            <span>Type of Pet</span>
            <span
              v-copy="getAllOptionName26('type_of_pet', item.type_of_pet)"
              :class="{'green-tip':compareChange(index,'pet_info','type_of_pet')}">{{ getAllOptionName26('type_of_pet', item.type_of_pet) }}</span>
          </div>
          <div class="tr">
            <span>Pet Name</span>
            <span
              v-copy="item.name"
              :class="{'green-tip':compareChange(index,'pet_info','name')}">{{ item.name }}</span>
          </div>
          <div class="tr">
            <span>Year of Birth</span>
            <span
              v-copy="item.dob"
              :class="{'green-tip':compareChange(index,'pet_info','dob')}">{{ item.dob }}</span>
          </div>
          <div class="tr">
            <span>Microchip No.</span>
            <span
              v-copy="item.microchip_no"
              :class="{'green-tip':compareChange(index,'pet_info','microchip_no')}">{{ item.microchip_no }}</span>
          </div>
          <!-- <div class="tr">
            <span>Microchip Copy</span>
            <span
              class="blue pointer"
              @click="openFile(item.microchip_copy_pic.url)">{{ item.microchip_copy_pic? item.microchip_copy_pic.client_name: '' }}</span>
          </div> -->
        </div>
      </template>
      <template v-if="hasBenefitsPhone">
        <h4>Accidental Damage to Mobile Phone</h4>
        <div class="table">
          <div class="tr">
            <span>Mobile Phone Model Name 1</span>
            <span
              v-copy="formData.phone_mdl_1"
              :class="{'green-tip':handleCompare('phone_mdl_1')}">{{ formData.phone_mdl_1 }}</span>
          </div>
          <div class="tr">
            <span>Mobile Phone Model Name 2</span>
            <span
              v-copy="formData.phone_mdl_2"
              :class="{'green-tip':handleCompare('phone_mdl_2')}">{{ formData.phone_mdl_2 }}</span>
          </div>
        </div>
      </template>
    </div>



    <div class="box">
      <h3>Remark(s)</h3>
      <div class="table">
        <div class="tr">
          <span>Remark</span>
          <span
            v-copy="changeLineData(formData.cs_manual_remark)"
            :class="{'green-tip':handleCompare('cs_manual_remark')}"
            v-html="changeLineData(formData.cs_manual_remark)"></span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapState} from 'vuex'
import dayjs from 'dayjs'
import OMath from '@/utils/math'

export default {
  name: 'HomefirePolicyInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    showAmount: {
      type: [String,Number],
      default: ''
    },
    isChange: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    isOther(){
      let {post_nm_id} = this.formData||{}
      let data ={}
      let {mortgagor=[] } = this.allOptions26||{}
      mortgagor.some(item => {
        if (item.id == post_nm_id) {
          data = item
          return true
        }
        return false
      })
      return data.is_other||''
    },
    isShowOwners(){
      let {prop_insured} = this.formData||{}
      return prop_insured!=3
    },
    amount(){
      return  OMath.formatMoney(this.showAmount, 2,true)
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    sidebarPremium() {
      let {quote_coverage_list={}} =this.formData||{}
      if(!quote_coverage_list) {
        return []
      }
      let { sidebar_premium=[]} =quote_coverage_list||{}
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium
    },
    option_benefits(){
      let {quote_coverage_list={}} = this.formData||{}
      let {more_benefit={}} = quote_coverage_list||{}
      let {sub_items={}} = more_benefit||{}
      let arr =[]
      if(sub_items){
        arr = Object.entries(sub_items).map(item=>item[1])
      }
      return arr
    },
    isSameAddress() {
      return this.formData.is_same_as_corr_addr == 1
    },
    hasBenefitsTab() {
      const { benefits = [],benefit_coverage = {} } = this.formData
      let {domestic_helper,mobile_phone,pet} = benefit_coverage||{}

      let result = false
      // if(this.isRefer){
      //   if(!benefits || benefits.length < 1) {
      //     return false
      //   }
      //
      //   benefits.some(item => {
      //     if([1, 4, 8].includes(item)) {
      //       result = true
      //     }
      //   })
      //
      // }
      benefits.some(item => {
        if([1, 4, 8].includes(item)) {
          result = true
        }
      })
      return domestic_helper||mobile_phone||pet||result
    },
    domesticHelperInfoList(){
      const {domestic_helper_info} = this.formData
      return domestic_helper_info || []
    },
    hasBenefitsEmployees() {
      const { benefits = [],benefit_coverage = {} } = this.formData
      const {domestic_helper=false} = benefit_coverage||{}

      if(benefits && benefits.includes(1)) {
        return true
      }
      return domestic_helper
    },
    hasBenefitsPets() {
      const { benefits = [],benefit_coverage ={} } = this.formData
      // const { benefit_coverage ={} } = this.form
      const {pet=false} = benefit_coverage||{}
      if(benefits && benefits.includes(4)) {
        return true
      }
      return pet
    },
    hasBenefitsPhone() {
      const { benefits = [],benefit_coverage = {} } = this.formData
      const {mobile_phone=false} = benefit_coverage||{}
      if(benefits && benefits.includes(8)) {
        return true
      }
      return mobile_phone
    },
    endDate(){
      let {pcy_cmnt_dt=''} = this.formData||{}
      return pcy_cmnt_dt?dayjs(pcy_cmnt_dt).add(1,'year').format('YYYY-MM-DD'):''
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      return items || []
    },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage={}} = quote_coverage_list||{}
      return  coverage
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preFormData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    },
    compareChange(){
      return (index,name,field)=>{
        let {type} = this.formData||{}
        let pre = this.preFormData||{}
        let preData =pre[name]||{}
        let nowData =this.formData[name]||{}
        if(type!=50)return  false
        if(preData.length<=0)return  false
        return nowData[index][name]!=preData[index][name]||false
      }
    }
  },
  methods: {
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    getName(id){
      let data = this.nationalityOptions.filter(item=>{
        return item.id==id
      })
      return data.length>0?data[0].name:''
    }
  }
}
</script>
<style lang="scss" scoped>
.quote-info{
  .box {
    margin-bottom: 15px;
  }
   .title {
    padding: 15px 0;
  }
  h4 {
    padding-bottom: 10px;
    color: #616266;
  }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
  .sub{
    padding: 5px;
    width: 100%;
    border-bottom: 1px solid #dddfe7;
    font-size: 12px;
    color: #606266;
    .sub-title{
      font-weight: bold;
    }
  }
  .sub:nth-child(2n){
    background: rgba(0, 0, 0, 0.02);
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
